const UPLOAD_CATEGORY_MAP = Object.freeze({
  THEME_LOGO: 'theme.logo',
  THEME_FAVICON: 'theme.favicon',
  THEME_LOGIN_BACKGROUND: 'theme.login_background',
  MISC_ORDER_HELP_NAME_IMAGE: 'misc.order_help.name_image',
  ADVERTISEMENT_TRACKING: 'advertisement.tracking',
  EMAIL_HEADER: 'email.header'
});

export const UPLOAD_CATEGORIES = Object.values(UPLOAD_CATEGORY_MAP);
